import React, { useEffect } from "react";
import { useMicrosite } from "../custom-hooks/useMicrosite";
import { useStore } from "../store";
import LoadingView from "../components/common/loadingView";
import "./style.scss";

export const withMicroSites = (Component) => {
  const MicroSites = (props) => {
    const { microSites } = useStore();
    const { microSiteLoading, getMicroSites } = useMicrosite();

    useEffect(() => {
      localStorage.setItem("page","home");
    },[]);

    useEffect(() => {
      getMicroSites();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (microSiteLoading) {
      return (
        <div>
          <LoadingView />
        </div>
      );
    } else {
      return (
        <div className="with-microsite">
          <div style={{ minHeight: "calc(100vh - 200px)" }}>  
            {microSites && microSites.length > 0 ? (
              <Component micrositeData={microSites} />
            ) : (
              <></>
            )}
          </div>
          <div className="with-microsite-header">
            <div className="footer-container">
              <div
                className="footer-content"
                onClick={() =>
                  window.open("https://www.connectsu.co.uk/", "_blank")
                }
                style={{ cursor: "pointer" }}
              >
                <div className="footer-logo">
                  <img src={require("../assets/images/PoweredNew.png")} alt="footer-logo" />
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  };

  return MicroSites;
};
